// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.topic-widget__container {
    position: fixed;
    bottom: 0;
    right: 8rem;
    width: 46.8rem;
    height: 100vh;
    z-index: 10;
}

.topic-widget__btn-expand {
    position: fixed;
    bottom: 3.2rem;
    right: 16.2rem;
}

.topic-widget__btn-expand,
.topic-widget__btn-close {
    display: flex;
    font-size: 50px;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    align-items: center;
    justify-content: center;
}

.topic-widget__btn-close {
    position: fixed;
    right: 54rem;
    top: 0;
    margin: 1.8rem;
}

.topic-widget {
    height: 100%;
    border: 1px solid #b0bec5;
    width: 100%;
    max-width: 800px;
    margin: auto;
    display: flex;
    flex-direction: column;
}

.topic-widget .topic-widget__header {
    height: 70px;
    display: flex;
    background-color: #26a69a;
    padding: 0 0 0 20px;
}

.topic-widget .topic-widget__title {
    display: flex;
    font-weight: 400;
    color: white;
    align-items: center;
}

.topic-widget .topic-widget__body {
    overflow: auto !important;
    height: 84vh;
}

    .topic-widget .topic-widget__footer {
        min-height: 100px;
        height: auto;
        border-top: 1px solid #b0bec5;
        overflow: visible;
    }
`, "",{"version":3,"sources":["webpack://./src/app/nlp/topic-editor/topic-widget/TopicWidget.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,SAAS;IACT,WAAW;IACX,cAAc;IACd,aAAa;IACb,WAAW;AACf;;AAEA;IACI,eAAe;IACf,cAAc;IACd,cAAc;AAClB;;AAEA;;IAEI,aAAa;IACb,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,MAAM;IACN,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;IAEI;QACI,iBAAiB;QACjB,YAAY;QACZ,6BAA6B;QAC7B,iBAAiB;IACrB","sourcesContent":[".topic-widget__container {\r\n    position: fixed;\r\n    bottom: 0;\r\n    right: 8rem;\r\n    width: 46.8rem;\r\n    height: 100vh;\r\n    z-index: 10;\r\n}\r\n\r\n.topic-widget__btn-expand {\r\n    position: fixed;\r\n    bottom: 3.2rem;\r\n    right: 16.2rem;\r\n}\r\n\r\n.topic-widget__btn-expand,\r\n.topic-widget__btn-close {\r\n    display: flex;\r\n    font-size: 50px;\r\n    border-radius: 50%;\r\n    width: 50px;\r\n    height: 50px;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.topic-widget__btn-close {\r\n    position: fixed;\r\n    right: 54rem;\r\n    top: 0;\r\n    margin: 1.8rem;\r\n}\r\n\r\n.topic-widget {\r\n    height: 100%;\r\n    border: 1px solid #b0bec5;\r\n    width: 100%;\r\n    max-width: 800px;\r\n    margin: auto;\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.topic-widget .topic-widget__header {\r\n    height: 70px;\r\n    display: flex;\r\n    background-color: #26a69a;\r\n    padding: 0 0 0 20px;\r\n}\r\n\r\n.topic-widget .topic-widget__title {\r\n    display: flex;\r\n    font-weight: 400;\r\n    color: white;\r\n    align-items: center;\r\n}\r\n\r\n.topic-widget .topic-widget__body {\r\n    overflow: auto !important;\r\n    height: 84vh;\r\n}\r\n\r\n    .topic-widget .topic-widget__footer {\r\n        min-height: 100px;\r\n        height: auto;\r\n        border-top: 1px solid #b0bec5;\r\n        overflow: visible;\r\n    }\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
